export const getCertificationPageGlobalTourSteps = t => [
  {
    target: '[data-tour="submissionInfo"]',
    message: t('demoTour.submissionInfo'),
  },
  {
    target: '[data-tour="dealerInfo"]',
    message: t('demoTour.dealerInfo'),
  },
  {
    target: '[data-tour="statusInfo"]',
    message: t('demoTour.statusInfo'),
  },
  {
    target: '[data-tour="scoreInfo"]',
    message: t('demoTour.scoreInfo'),
  },
  {
    target: '[data-tour="productLineInfo"]',
    message: t('demoTour.productLineInfo'),
  },
  {
    target: '[data-tour="submissionWizard"]',
    message: t('demoTour.submissionWizard'),
  },
  {
    target: '[data-tour="heroUnit"]',
    message: t('demoTour.heroUnit'),
  },
];
